import { render, staticRenderFns } from "./MarketCode.vue?vue&type=template&id=1e0c8b0d&"
import script from "./MarketCode.vue?vue&type=script&lang=js&"
export * from "./MarketCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports